export default {
    //移动端获取基本信息
    getBaseInfo: () => {
        if (window["getBaseInfo"]) {
            return window["getBaseInfo"].postMessage("")
        }
    },
    //移动端退出当前页面
    backToPrimary: () => {
        if (window["backToPrimary"]) {
            return window["backToPrimary"].postMessage("")
        }
    },
    //调用flutter图片上传
    pickImageFromFlutter: () => {
        if (window["pickImageFromFlutter"]) {
            return window["pickImageFromFlutter"].postMessage("")
        }
    },
    //基本调用封装(vue调用flutter)
    getFlutterData: (value, data) => {
        if (window[value]) {
            return window[value].postMessage(data ? data : "")
        }
    },
    //flutter图片返回
    postImageInfoToJS: () => {
        window["postImageInfoToJS"] = (data) => {
            alert(JSON.stringify(data?data:"没收到"))
            return data
        };
    },
    //基本调用封装(flutter调用vue)将对应方法添加进window中
    giveFlutterData: (value) => {
        window[value] = (data) => {
            return data
        };
    },
}